import { getDatabase, ref, set } from "firebase/database";

export default function resetNotificationCounter(uId: string, notificationLink: string) {
    uId && notificationLink && set(ref(getDatabase(), `notificationCounters/${uId}/${notificationLink}`), 0);
}
